import dynamic from 'next/dynamic';
import React from 'react';

// Import PlayerButton dynamically with SSR disabled to avoid hydration issues
const FeatureLayoutPlayerButton = dynamic(() => import('./PlayerButton'), {
  ssr: false,
  loading: () => (
    <div className="controls">
      <div className="button-holder -live">
        <div className="player-button"></div>
      </div>
    </div>
  ),
});

// Types should match the PlayerButton component
type FeatureLayoutPlayerButtonProps = {
  inDropDown?: boolean;
  customTitle?: string | React.ReactNode;
};

const PlayerButtonWrapper: React.FC<FeatureLayoutPlayerButtonProps> = (
  props
) => {
  return <FeatureLayoutPlayerButton {...props} />;
};

export default PlayerButtonWrapper;
